<template>
  <v-container fluid>
	
    <v-row v-if="Array.isArray(orders) && orders.length > 0">
		
		<v-col cols="3" lg="2" v-for="(order) in filteredOrders" :key="order.uuid + ':' + order.state">
			<Order
				:key="order.uuid"
				v-if="order !== null && order !== undefined && order.lineItems !== null && order.lineItems.length > 0"
				:order="order"
				@clickOrder="selectOrder"
			/>
		</v-col>

    </v-row>

  </v-container>
</template>

<script>
	import OrderError from './OrderError'

	const moment = require('moment')

	export default {
		name: 'Orders',
		components: {
			'Order': () => import('./Order'),		
		},
		props: {
			orders: {
				type: Array,
				required: true
			}
		},
		data: () => ({
			refreshKey: 1,
			orderError: OrderError
		}),
		computed: {
			filteredOrders() {
				return this.orders.filter(element => this.hasItemsInCategoryFilter(element))
			},
			processDisplaySystem() {
				return this.$store.state.processDisplaySystem
			},
			selectedOrders() {
				return this.$store.state.selectedOrders
			},
		},
		methods: {
			onSocketMessage() {

			},
			onSocketConnection() {

			},
			hasItemsInCategoryFilter(order) {
				// If the processDisplaySystem has a defined category-filter then check if order contains at least one item that fits the category filter.
				if (this.processDisplaySystem !== null && this.processDisplaySystem !== undefined && Array.isArray(this.processDisplaySystem.categories) && this.processDisplaySystem.categories.length > 0) {
					let validCategories = this.processDisplaySystem.categories.reduce((array, category) => {
						if(category && category.uuid) {
							array.push(category.uuid)
						}
						return array
					}, [])

					for (let lineItem in order.lineItems) {
						const lineItemToCheck = order.lineItems[lineItem]

						if (lineItemToCheck === null || lineItemToCheck === undefined) {
							continue
						}

						if (lineItemToCheck.item === null || lineItemToCheck.item === undefined) {
							continue
						}

						if (lineItemToCheck.item.categories === null || lineItemToCheck.item.categories === undefined) {
							continue
						}

						const intersection = lineItemToCheck.item.categories.filter(element => validCategories.includes(element.uuid));

						if (Array.isArray(intersection) && intersection.length > 0) {
							return true
						}
					}

					return false
				}

				// If the processDisplaySystem does not have a defined category filter we simply show the order.
				return true
			},
			selectOrder(order) {

				// Need to add alert
				if(this.selectedOrders.length > 0) {
					return
				}

				this.$store.commit('selectOrder', order)
			},
			getOrderData() {
				if(this.processDisplaySystem !== null && this.processDisplaySystem !== undefined) {

				this.$store.dispatch('subscribeOrderData', {
					startTimeInMillis: moment().subtract(3, 'days').startOf('day').valueOf(),
					endTimeInMillis: moment().endOf('day').valueOf()
				})
				}

				if(this.processDisplaySystem !== null && this.processDisplaySystem !== undefined && this.processDisplaySystem.posChannel !== null && this.processDisplaySystem !== undefined) {
					this.$store.dispatch('subscribePosOrderData')
				}
			}
		},
		mounted() {
			this.getOrderData()
		}
	}
</script>
